<template>
  <v-container fluid>
    <!-- Scheduled Email Campaigns - Calendar view -->
    <!-- Also Shows completed Scheduled Email Campaigns -->
    <v-col cols="12">
      <v-row class="child-flex">
        <scheduled-email-campaigns :allDealers="false" :showDealersColumn="false"
          :allowCreateNew="true"></scheduled-email-campaigns>
      </v-row>

      <!--
        Unscheduled Email Campaigns
      -->
      <v-row class="child-flex">
        <v-card>
          <v-card-text>
            <v-card-title>
              Unscheduled Email Campaigns
              <refresh-spinner v-model="isRefreshingData" @click="refreshList"></refresh-spinner>
              <v-spacer></v-spacer>
              <v-switch v-model="showAllUnscheduledTags" :label="showAllUnscheduledTags ? 'Hide Tags' : 'Show Tags'" />
              <v-spacer></v-spacer>
              <v-autocomplete v-model="unscheduledTagFilter" :items="campaignTags" chips small-chips multiple clearable
                deletable-chips persistent-hint hint="Filter By Campaign Tags" />
              <v-spacer></v-spacer>
              <v-text-field @keydown.native.escape="unscheduledSearch = ''" label="Search" single-line clearable
                v-model="unscheduledSearch" persistent-hint hint="Filter by name">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" :to="{ 'name': 'new_email_campaign_path' }">
                <v-icon left>mdi-plus</v-icon>
                New Campaign
              </v-btn>
            </v-card-title>
          </v-card-text>
          <v-data-table :headers=unscheduledCampaignColumns :items=unscheduledCampaigns item-key='id'
            class="elevation-1" show-expand :expanded.sync="unscheduleExpandedTagList">
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <span class="pl-12 pr-6">Tags for {{ item.name }}</span>
                <template v-for="tag in item.tags">
                  <v-chip small v-bind:key="'tag' + item.id + tag" color="orange">
                    {{ tag }}
                  </v-chip>
                </template>
              </td>
            </template>
            <template v-slot:item.email_type="{ item }">
              <v-chip :color="emailTypeColor(item.email_type)" small>
                {{ item.email_type | titleize }}
              </v-chip>
            </template>
            <template v-slot:item.schedule_type="{ item }">
              <v-icon :color="scheduleTypeColor(item.schedule_type)">{{ scheduleTypeIcon(item.schedule_type) }}</v-icon>
              {{ item.schedule_type | capitalize }}
            </template>
            <template v-slot:item.is_split_tested="{ item }">
              <v-icon v-if="item.is_split_tested" :color="scheduleTypeColor(item.schedule_type)">mdi-ab-testing</v-icon>
            </template>

            <!-- <template v-slot:item.next_run="{ item }">
              {{ formatExecutionTime(item.next_run) }}
            </template> -->
            <template v-slot:item.last_run="{ item }">
              {{ item.last_run | usDateTime }}
            </template>

            <template v-slot:item.sent_count="{ item }">
              {{ item.sent_count | zeroIfNull }}
            </template>
            <template v-slot:item.delivered_count="{ item }">
              {{ item.delivered_count | zeroIfNull }}
            </template>
            <template v-slot:item.unique_click_count="{ item }">
              {{ item.unique_click_count | zeroIfNull }}
            </template>
            <template v-slot:item.unique_open_count="{ item }">
              {{ item.unique_open_count | zeroIfNull }}
            </template>
            <template v-slot:item.actions="{ item }">
              <template v-for="(rowAction, index) in unscheduledCampaignActions">
                <v-tooltip top :key="index">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" medium class="mr-2" @click="executeAction(rowAction.action, item)">{{
                      rowAction.icon
                      }}</v-icon>
                  </template>
                  <span>{{ rowAction.title }}</span>
                </v-tooltip>
              </template>
            </template>
          </v-data-table>
        </v-card>
      </v-row>

      <!--
        Scheduled campaigns list
      -->
      <v-row class="child-flex">
        <v-card>
          <v-card-text>
            <v-card-title>
              Complete and Upcoming Campaigns
              <refresh-spinner v-model="isRefreshingData" @click="refreshList"></refresh-spinner>
              <v-spacer></v-spacer>
              <v-switch v-model="showAllScheduledTags" :label="showAllScheduledTags ? 'Hide Tags' : 'Show Tags'" />
              <v-spacer></v-spacer>
              <v-autocomplete v-model="scheduledTagFilter" :items="campaignTags" chips small-chips deletable-chips
                multiple clearable persistent-hint hint="Filter By Campaign Tags" />
              <v-spacer></v-spacer>
              <v-text-field @keydown.native.escape="search = ''" label="Search" single-line clearable persistent-hint
                hint="Filter by name" v-model="search">
              </v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" :to="{ 'name': 'new_email_campaign_path' }">
                <v-icon left>mdi-plus</v-icon>
                New Campaign
              </v-btn>
            </v-card-title>
          </v-card-text>

          <v-data-table :headers=tableColumns :items=scheduledCampaigns item-key='id' class="elevation-1" show-expand
            :expanded.sync="scheduleExpandedTagList">
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <span class="pl-12 pr-6">Tags for {{ item.name }}</span>
                <template v-for="tag in item.tags">
                  <v-chip small v-bind:key="'tag' + item.id + tag" color="orange">
                    {{ tag }}
                  </v-chip>
                </template>
              </td>
            </template>
            <template v-slot:item.name="{ item }">
              <router-link :to="{ name: 'email_campaign_path', params: { id: item.id } }">
                {{ item.name }}
              </router-link>
            </template>
            <template v-slot:item.email_type="{ item }">
              <v-chip :color="emailTypeColor(item.email_type)" small>
                {{ item.email_type | titleize }}
              </v-chip>
            </template>
            <template v-slot:item.is_split_tested="{ item }">
              <v-icon v-if="item.is_split_tested" :color="scheduleTypeColor(item.schedule_type)">mdi-ab-testing</v-icon>
            </template>
            <template v-slot:item.schedule_type="{ item }">
              <v-icon :color="scheduleTypeColor(item.schedule_type)">{{ scheduleTypeIcon(item.schedule_type) }}</v-icon>
              {{ item.schedule_type | capitalize }}
            </template>
            <template v-slot:item.sent_count="{ item }">
              {{ item.sent_count | zeroIfNull }}
            </template>
            <template v-slot:item.delivered_count="{ item }">
              {{ item.delivered_count | zeroIfNull }}
            </template>
            <template v-slot:item.unique_click_count="{ item }">
              {{ item.unique_click_count | zeroIfNull }}
            </template>
            <template v-slot:item.unique_open_count="{ item }">
              {{ item.unique_open_count | zeroIfNull }}
            </template>
            <template v-slot:item.next_run="{ item }">
              {{ formatExecutionTime(item.next_run) }}
            </template>
            <template v-slot:item.last_run="{ item }">
              {{ item.last_run | usDateTime }}
            </template>

            <template v-slot:item.actions="{ item }">
              <template v-for="(rowAction, index) in actions">
                <v-tooltip top :key="index">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" medium class="mr-2" @click="executeAction(rowAction.action, item)">{{
                      rowAction.icon
                      }}</v-icon>
                  </template>
                  <span>{{ rowAction.title }}</span>
                </v-tooltip>
              </template>
            </template>
          </v-data-table>
        </v-card>
      </v-row>

    </v-col>
    <v-overlay :value="isGeneratingPdf">
      <p>Generating Campaign Details PDF</p>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import RefreshSpinner from '@/components/ui/RefreshSpinner'
import ScheduledCampaigns from './ScheduledCampaigns'
import ScheduleTypeHelperMixin from './ScheduleTypeHelperMixin'
import { EmailTemplateApi, EmailCampaignApi } from '@/services'
import { DateTime } from 'luxon'
const R = require('ramda')
import R4UtilsApi from '@/services/api/r4UtilsApi'

// A superset is a set that contains all the elements of another set.
// Range 10..40 is a superset of range 20..30 because 10..40 contains all 20..30
// Leaving in in case we need to change - originally used isSupserset rather than hasIntersect
// function isSuperset (set, subset) {
//   // in this case, set is what we want filtered - if empty, do not filter anything
//   if (set.size === 0) return false

//   for (let elem of subset) {
//     if (!set.has(elem)) {
//       return false
//     }
//   }
//   return true
// }

function hasIntersect(setA, setB) {
  for (let elem of setA) {
    if (setB.has(elem)) {
      return true
    }
  }
  return false
}

export default {
  mixins: [ScheduleTypeHelperMixin],
  components: {
    [RefreshSpinner.name]: RefreshSpinner,
    [ScheduledCampaigns.name]: ScheduledCampaigns
  },
  computed: {
    ...mapState('EmailCampaignStore', { tableData: 'emailCampaigns' }),
    ...mapState('DealerStore', ['dealer']),
    ...mapState('ApplicationStore', ['dealerScopedView']),
    scheduledData() {
      return this.tableData.filter(campaign => {
        return campaign.status === 'scheduled'
      })
    },
    scheduledCampaigns() {
      let campaignsList = null
      const tagSet = new Set(this.scheduledTagFilter)

      if (tagSet.size > 0) {
        campaignsList = this.scheduledData.filter(row => {
          return hasIntersect(tagSet, new Set(row.tags))
        })
      } else {
        campaignsList = this.scheduledData
      }

      if (!this.search) {
        return campaignsList
      }

      let result = campaignsList.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          let rowValue = R.pathOr('', key.split('.'), row).toString()
          if (rowValue.includes && rowValue.toLowerCase().includes(this.search.toLowerCase())) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    },
    unscheduledData() {
      return this.tableData.filter(campaign => {
        return campaign.status === 'unscheduled'
      })
    },
    unscheduledCampaigns() {
      let campaignsList = null
      const tagSet = new Set(this.unscheduledTagFilter)

      if (tagSet.size > 0) {
        campaignsList = this.unscheduledData.filter(row => {
          return hasIntersect(tagSet, new Set(row.tags))
        })
      } else {
        campaignsList = this.unscheduledData
      }

      if (!this.unscheduledSearch) {
        return campaignsList
      }
      let result = campaignsList.filter(row => {
        let isIncluded = false
        for (let key of this.propsToSearch) {
          let rowValue = R.pathOr('', key.split('.'), row).toString()
          if (rowValue.includes && rowValue.toLowerCase().includes(this.unscheduledSearch.toLowerCase())) {
            isIncluded = true
          }
        }
        return isIncluded
      })
      return result
    }

  },
  data: function () {
    return {
      // scheduled
      search: '',
      scheduledTagFilter: [],
      scheduleExpandedTagList: [],
      showAllScheduledTags: false,

      // unscheduled
      unscheduledSearch: '',
      unscheduledTagFilter: [],
      unscheduleExpandedTagList: [],
      showAllUnscheduledTags: false,

      propsToSearch: ['name'],
      tableColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Email Type', value: 'email_type' },
        { text: 'Schedule Type', value: 'schedule_type' },
        { text: 'A/B Test', value: 'is_split_tested' },
        { text: 'Last Run', value: 'last_run' },
        { text: 'Next Run', value: 'next_run' },
        { text: 'Sent', value: 'sent_count' },
        { text: 'Delivered', value: 'delivered_count' },
        { text: 'Unique Opens', value: 'unique_open_count' },
        { text: 'Unique Clicks', value: 'unique_click_count' },
        { text: 'Actions', value: 'actions' }
      ],
      actions: [
        { title: 'Edit', action: 'edit', icon: 'mdi-pencil' },
        { title: 'View Report', action: 'show', icon: 'mdi-file-chart' },
        { title: 'Preview Email', action: 'handlePreview', icon: 'mdi-binoculars' },
        { title: 'Delete', action: 'handleDelete', icon: 'mdi-delete' },
        { title: 'PDF Campaign Details', action: 'handleDetailPdf', icon: 'mdi-file-pdf-box' }
      ],
      unscheduledCampaignColumns: [
        { text: 'Name', value: 'name' },
        { text: 'Email Type', value: 'email_type' },
        { text: 'Schedule Type', value: 'schedule_type' },
        { text: 'A/B Test', value: 'is_split_tested' },
        { text: 'Last Run', value: 'last_run' },
        // { text: 'Next Run', value: 'next_run' },
        { text: 'Sent', value: 'stats.sent' },
        { text: 'Delivered', value: 'stats.delivered' },
        { text: 'Unique Opens', value: 'stats.unique_open' },
        { text: 'Unique Clicks', value: 'stats.unique_click' },
        { text: 'Actions', value: 'actions' }
      ],
      unscheduledCampaignActions: [
        { title: 'Edit', action: 'edit', icon: 'mdi-pencil' },
        { title: 'View Report', action: 'show', icon: 'mdi-file-chart' },
        { title: 'Preview Email', action: 'handlePreview', icon: 'mdi-binoculars' },
        { title: 'Delete', action: 'handleDelete', icon: 'mdi-delete' }
      ],
      isRefreshingData: false,
      isGeneratingPdf: false,
      campaignTags: [] // holds list of campaign tags
    }
  },
  watch: {
    dealer: function (newDealer, oldDealer) {
      this.refreshList()
    },
    showAllScheduledTags: function (newVal, oldVal) {
      if (newVal) {
        this.scheduleExpandedTagList = this.scheduledCampaigns
      } else {
        this.scheduleExpandedTagList = []
      }
    },
    showAllUnscheduledTags: function (newVal, oldVal) {
      if (newVal) {
        this.unscheduleExpandedTagList = this.unscheduledCampaigns
      } else {
        this.unscheduleExpandedTagList = []
      }
    }
  },
  methods: {
    formatExecutionTime(time, valueIfNull = 'COMPLETE') {
      if (time) {
        return DateTime.fromISO(time).toLocaleString(DateTime.DATETIME_SHORT)
      } else {
        return valueIfNull
      }
    },
    refreshList() {
      this.isRefreshingData = true
      const queryParams = this.dealerScopedView ? { dealer_id: this.dealer.id } : {}
      return this.$store.dispatch('EmailCampaignStore/fetchEmailCampaigns', queryParams)
        .then(() => {
          return EmailCampaignApi.allCampaignTags()
        })
        .then((resp) => {
          this.campaignTags = resp.data
          this.isRefreshingData = false
        })
        .catch(error => {
          this.$flash({
            showClose: true,
            message: `Error Loading Email Campaigns. ${error.message}`,
            type: 'error',
            duration: 0
          })
          this.isRefreshingData = false
        })
    },
    executeAction(action, item) {
      this[action](item)
    },
    edit(item) {
      this.$router.push({ name: 'edit_email_campaign_path', params: { id: item.id } })
    },
    show(item) {
      this.$router.push({ name: 'email_campaign_path', params: { id: item.id } })
    },
    handleDelete(item) {
      const shouldDelete = confirm('Are you sure you want to delete?')
      if (shouldDelete) {
        return this.$store.dispatch('EmailCampaignStore/deleteEmailCampaign', item)
          .then(() => {
            this.refreshList()
            this.$flash({
              showClose: true,
              message: 'Deleted Email Campaign',
              type: 'mini',
              duration: 2000
            })
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error Deleting Email Campaign. ' + error.message,
              type: 'error',
              duration: 0
            })
          })
      }
    },
    handlePreview(item) {
      if (item.email_template_id) {
        EmailTemplateApi.getHtmlPreview({
          emailTemplateId: item.email_template_id,
          emailTemplateFooterId: item.email_template_footer_id,
          rooftopId: item.dealer_rooftop_id,
          dealerId: item.dealer_id
        })
          .then((htmlTemplatePreview) => {
            R4UtilsApi.openHtmlInNewTab(htmlTemplatePreview.data.html)
          })
          .catch(error => {
            this.$flash({
              showClose: true,
              message: 'Error Loading Email Templates. Reload to try again.' + error.message,
              type: 'error',
              duration: 0
            })
          })
      } else {
        alert('This Email Campaign does not have an associated email template to preview.')
      }
    },
    handleDetailPdf(item) {
      if (item.id) {
        this.isGeneratingPdf = true
        EmailCampaignApi.fetchDetailsPdf(item.id)
          .then((details) => {
            const downloadLink = document.createElement('a')
            downloadLink.setAttribute('href', details.data.url)
            downloadLink.setAttribute('style', 'display:none')
            downloadLink.setAttribute('target', '_blank')
            document.body.append(downloadLink)

            setTimeout(function () {
              downloadLink.click()
              downloadLink.remove()
            }, null)
            this.isGeneratingPdf = false
          })
          .catch(error => {
            this.$logger.error(error.message)
            this.isGeneratingPdf = false
            this.$flash({
              showClose: true,
              message: 'Error generating PDF details.' + error.message,
              type: 'error',
              duration: 0
            })
          })
      }
    },
    emailTypeColor(emailType) {
      if (emailType === 'promotional') {
        return 'green'
      } else if (emailType === 'transactional') {
        return 'light-blue'
      } else {
        return 'default'
      }
    }

  },
  mounted: function () {
    return this.refreshList()
  }
}
</script>
